module.exports = __webpack_public_path__ + "media/images/icon-comment-best@3x-e22c59cd5690c8dc40d53fdf03a7d68e.png";